import { apiRequest } from '../api/client';
import type { PresignedUrlData, PresignedUrlRequestBody } from './ingestion.types';

export const ingestionService = {
  /** POST `/files/presigned-url` — get upload URL and storage path. */
  postFilesPresignedUrl: async (body: PresignedUrlRequestBody): Promise<PresignedUrlData> => {
    const data = await apiRequest<PresignedUrlData>({
      method: 'POST',
      url: '/files/presigned-url',
      data: body,
    }, 'Presigned URL request failed');

    if (!data?.upload_url || !data?.path) {
      throw new Error('Presigned URL response is missing upload target details');
    }

    return data;
  },

  /** Upload file bytes to storage using a pre-signed URL. */
  putFileToPresignedUrl: async (
    uploadUrl: string,
    file: File,
    contentType: string
  ): Promise<void> => {
    const res = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': contentType,
      },
    });

    if (!res.ok) {
      throw new Error(`Upload to storage failed (${res.status})`);
    }
  },

  /** Derive MIME type for the presigned URL request from file extension. */
  contentTypeForSourceFileName: (fileName: string): string => {
    const ext = fileName.toLowerCase().split('.').pop() ?? '';
    switch (ext) {
      case 'csv':
        return 'text/csv';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'txt':
        return 'text/plain';
      case 'tsv':
        return 'text/tab-separated-values';
      default:
        return 'application/octet-stream';
    }
  },
};

export default ingestionService;
